const serviceGroupsData = [
    {
        id: 1,
        slug: 'orthopedics-non-surgical-pain-management',
        title: 'Orthopedics & Non-Surgical Pain Management',
        // imageUrl: bonehealth,
        description: 'Non-surgical Ayurvedic care for heel pain, sciatica, joint pain, frozen shoulder, knee pain, and chronic inflammatory pain.',
    },
    {
        id: 2,
        slug: 'skin-hair-advanced-blood-purification',
        title: 'Skin, Hair & Advanced Blood Purification',
        // imageUrl: jointcare,
        description: 'Ayurvedic treatments for varicose veins, acne, psoriasis, hair loss, scalp care, and advanced blood purification.',
    },
    {
        id: 3,
        slug: 'stress-sleep-mental-wellness',
        title: 'Stress, Sleep & Mental Wellness',
        // imageUrl: pregcare,
        description: 'Ayurvedic therapies for anxiety, high stress, insomnia, relaxation, and full-body rejuvenation.',
    },
    {
        id: 4,
        slug: 'eye-ear-head-rejuvenation',
        title: 'Eye, Ear & Head Rejuvenation (ENT)',
        // imageUrl: stomachhealth,
        description: 'Ayurvedic care for dry eyes, dark circles, sinusitis, tinnitus, ear issues, respiratory congestion, and head health.',
    },
    {
        id: 5,
        slug: 'digestive-detox-lifestyle-management',
        title: 'Digestive, Detox & Lifestyle Management',
        // imageUrl: bonehealth,
        description: 'Ayurvedic detox, colon cleanse, weight loss, dietary planning, and seasonal immunity care.',
    },
    {
        id: 6,
        slug: 'maternal-pediatrics-custom-services',
        title: 'Maternal, Pediatrics & Custom Services',
        // imageUrl: stomachhealth,
        description: 'Prenatal care, pediatric immunity programs, general consultations, medicine delivery, cupping, and yoga therapy.',
    }
];

export default serviceGroupsData;
